module.exports = __webpack_public_path__ + "static/media/promocoes-cashback-mobile.5af7fa4b.jpg";